import { useEffect, useState } from "react";
import { loadData } from "../http/fetch-status";
import CareerIcon from "./career-icon";
import Careers from "./careers";
import Status from "./status";
import ZoneTracker from "./zone-tracker";
import CampaingTrends from "./campaign-trends";
import Hero from "./hero";
import Guilds from "./guilds";
import CareerTrends from "./career-trends";

const Main = () => {
  const [data, setData] = useState();
  const [tab, setTab] = useState("rvr");

  const urlParams = new URLSearchParams(window.location.search);
  const pwd = urlParams.get("pwd");
  const secret = pwd === "8549";

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const response = await loadData();
    setData(response.data);
  };

  let total_pop = 0;
  let total_order = 0;
  let total_destro = 0;
  let order_kills = 0;
  let destro_kills = 0;
  let destro_guilds = {};
  let order_guilds = {};
  let destro_careers = {};
  let order_careers = {};

  if (data) {
    const day = data.slice(0, 48);

    day.forEach((status) => {
      total_pop += status.population.population;
      total_order += status.population.order;
      total_destro += status.population.destro;
      if (status.kills) {
        const zones = Object.keys(status.kills);
        zones.forEach((zone) => {
          order_kills += status.kills[zone].order_kills;
          destro_kills += status.kills[zone].destro_kills;
          const destro_guild_kills = status.kills[zone].destro_guilds;
          const order_guild_kills = status.kills[zone].order_guilds;
          const destro_career_kills = status.kills[zone].destro_careers;
          const order_career_kills = status.kills[zone].order_careers;
          destro_guild_kills.forEach((guild) => {
            if (destro_guilds[guild[0]]) {
              destro_guilds[guild[0]] += guild[1];
            } else {
              destro_guilds[guild[0]] = guild[1];
            }
          });
          order_guild_kills.forEach((guild) => {
            if (order_guilds[guild[0]]) {
              order_guilds[guild[0]] += guild[1];
            } else {
              order_guilds[guild[0]] = guild[1];
            }
          });

          if (destro_career_kills) {
            destro_career_kills.forEach((guild) => {
              if (destro_careers[guild[0]]) {
                destro_careers[guild[0]] += guild[1];
              } else {
                destro_careers[guild[0]] = guild[1];
              }
            });
          }

          if (order_career_kills) {
            order_career_kills.forEach((guild) => {
              if (order_careers[guild[0]]) {
                order_careers[guild[0]] += guild[1];
              } else {
                order_careers[guild[0]] = guild[1];
              }
            });
          }
        });
      }
    });
  }

  const xorder =
    order_guilds &&
    Object.keys(order_guilds).map((key) => {
      return [key, order_guilds[key]];
    });

  xorder.sort(function (first, second) {
    return second[1] - first[1];
  });

  const xdestro =
    destro_guilds &&
    Object.keys(destro_guilds).map((key) => {
      return [key, destro_guilds[key]];
    });

  xdestro.sort(function (first, second) {
    return second[1] - first[1];
  });

  const xdestroCareer =
    destro_careers &&
    Object.keys(destro_careers).map((key) => {
      return [key, destro_careers[key]];
    });

  xdestroCareer.sort(function (first, second) {
    return second[1] - first[1];
  });

  const xorderCareer =
    order_careers &&
    Object.keys(order_careers).map((key) => {
      return [key, order_careers[key]];
    });

  xorderCareer.sort(function (first, second) {
    return second[1] - first[1];
  });

  return (
    <div className="main">
      <div className=" container mx-auto">
        <div className="uppercase">
          <div className="pt-5 md:pt-10 text-xl font-bold ror-font text-[28px] text-center">
            Stats
          </div>
          <div className="text-xl font-bold ror-font text-[12px] text-center leading-[0.5px]">
            for the
          </div>
          <div className="pb-5 md:pb-10 text-xl font-bold ror-font text-[28px] text-center">
            Stats God
          </div>
        </div>
        {/*<div className="mb-10 text-lg bg-green-600 text-white px-4 py-4">
              <p style={{ fontSize: "26px" }}>Happy Days :)</p>
              <p style={{ fontSize: "18px" }}>
                The ROR Team have offered to host this site on their servers so no
                immininent shutdown. Thanks guys!
              </p>
              <p style={{ fontSize: "18px" }}>-- Vaul/Mainline.</p>
      </div>*/}
        <div className="mb-4">
          <select onClick={(e) => setTab(e.target.value)}>
            <option value="rvr">Campaign Stats</option>
            {<option value="rvr-trends">Campaign Trends</option>}
            <option value="hero">Warriors of Reckoning</option>
            <option value="zonetracker">Zone Tracker</option>
            {<option value="careers">Career Stats</option>}
            {<option value="career-trends">Career Trends</option>}
            {secret && <option value="guilds">Guild Stats</option>}
          </select>
        </div>
        {tab === "hero" && <Hero />}
        {tab === "guilds" && <Guilds />}
        {tab === "zonetracker" && <ZoneTracker status={data} />}
        {tab === "rvr-trends" && <CampaingTrends />}
        {tab === "career-trends" && <CareerTrends />}
        {tab === "rvr" && (
          <>
            <div className="bg-ror p-2 md:p-5 mb-10">
              <div className="text-lg font-bold mb-5">
                Last 24H Summary oRVR
              </div>
              <div className="grid md:grid-cols-12 text-sm gap-5">
                <div className="md:col-span-2 space-y-2">
                  <div>Avg. T2+ Pop. {(total_pop / 48).toFixed()}</div>
                  <div className="flex w-full">
                    <div className="text-sky-400 font-bold ">
                      {((100 * total_order) / total_pop).toFixed(0)}%
                    </div>
                    <div
                      className="bg-sky-500 h-4 mt-1 ml-2"
                      style={{
                        width: (50 * total_order) / total_pop + "%",
                        //backgroundColor: "#f90",
                      }}
                    ></div>
                    <div
                      className="bg-red-500 h-4 mt-1 mr-2"
                      style={{
                        width: (50 * total_destro) / total_pop + "%",
                        //backgroundColor: "#f90",
                      }}
                    ></div>
                    <div className="text-red-400 font-bold">
                      {((100 * total_destro) / total_pop).toFixed(0)}%
                    </div>
                  </div>
                </div>
                <div className="md:col-span-10">
                  <div className="text-sky-400 mb-5">
                    <div className="w-full flex mb-2 space-x-2">
                      <div>Kills: {order_kills} </div>
                      <div
                        className="bg-sky-500 h-2 mt-2"
                        style={{
                          width: order_kills / 300 + "%",
                        }}
                      ></div>
                      <div>
                        {(
                          (100 * order_kills) /
                          (destro_kills + order_kills)
                        ).toFixed()}
                      </div>
                      %
                    </div>
                    <div className="col-span-8 text-xxs text-white">
                      <div className="space-x-0.5 text-white">
                        {xorder.slice(0, 5).map((guild) => {
                          return (
                            <>
                              {"<" + guild[0] + ">"}
                              {guild[1]}
                            </>
                          );
                        })}
                      </div>
                      <div className="space-x-2 text-xxs text-white flex h-6 mt-2">
                        {xorderCareer.slice(0, 6).map((guild) => {
                          return (
                            <>
                              {<CareerIcon career={guild[0]} />} {guild[1]}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                  <div className="text-red-400  md:space-y-5">
                    <div className="flex w-full mb-2 space-x-2">
                      <div>Kills: {destro_kills} </div>
                      <div
                        className="bg-red-500 h-2 mt-2"
                        style={{
                          width: destro_kills / 300 + "%",
                        }}
                      ></div>
                      <div>
                        {(
                          (100 * destro_kills) /
                          (destro_kills + order_kills)
                        ).toFixed()}
                        %
                      </div>
                    </div>
                    <div className="col-span-8 text-xs">
                      <div className=" space-x-1 text-xxs text-white">
                        {xdestro.slice(0, 5).map((guild) => {
                          return (
                            <span>
                              {"<" + guild[0] + ">"}
                              {guild[1]}
                            </span>
                          );
                        })}
                      </div>
                      <div className="mt-2 space-x-2 text-xxs text-white flex h-6">
                        {xdestroCareer.slice(0, 6).map((guild) => {
                          return (
                            <>
                              {<CareerIcon career={guild[0]} />} {guild[1]}
                            </>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>
                <div></div>
              </div>
            </div>
            <div>
              {data &&
                data.slice(0, 50).map((d) => {
                  return <Status data={d} />;
                })}
            </div>
          </>
        )}
        {tab === "careers" && <Careers />}
      </div>
    </div>
  );
};

export default Main;
